import { render, staticRenderFns } from "./SelectCustom.vue?vue&type=template&id=6aa8c781&scoped=true"
import script from "./SelectCustom.vue?vue&type=script&lang=js"
export * from "./SelectCustom.vue?vue&type=script&lang=js"
import style0 from "./SelectCustom.vue?vue&type=style&index=0&id=6aa8c781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8c781",
  null
  
)

export default component.exports